var map = {
	"./200 Big Ben 2.jpg": "cb06",
	"./200 Big Ben.jpg": "6fa1",
	"./200 Eiffel Tower.jpg": "32cd",
	"./200 Kalon.jpg": "70a1",
	"./200 Statue of Liberty.jpg": "52e5",
	"./200 Taj Mahal.jpg": "9670",
	"./200 The Shard.jpg": "6f76"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc06";